import { render, staticRenderFns } from "./dashboard_adv.vue?vue&type=template&id=346b656b&"
import script from "./dashboard_adv.vue?vue&type=script&lang=js&"
export * from "./dashboard_adv.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_adv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports